import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { useAuthStore } from '@/modules/user/stores';

import { BeneficiaryType, GET_BENEFICIARIES_QUERY_KEY } from './useGetBeneficiaries.query';

interface Props {
  onSuccess?: () => void;
  beneficiaryType?: BeneficiaryType;
}

const useDeleteBeneficiariesQuery = ({ beneficiaryType, onSuccess }: Props) => {
  const { user } = useAuthStore();
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isSuccess } = useMutation(() =>
    api.delete(API_URL.EMPLOYEES_BENEFICIARIES_BY_EMPLOYEE_ID_TYPE(user?.employee?.id || '', beneficiaryType || '')),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_BENEFICIARIES_QUERY_KEY] });
        if (onSuccess) onSuccess();
      },
    }
  );
  return {
    isSuccess,
    deleteBeneficiaries: mutateAsync,
    isLoading,
  };
};

export default useDeleteBeneficiariesQuery;
